import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLogin from "./pages/AdminLogin";
import OrdersPage from "./pages/OrdersPage";
import SubscriptionsPage from "./pages/SubscriptionsPage";
import { auth, db } from "./firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setIsAuthenticated(true);

        // Firestore'dan kullanıcının rolünü çek
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const role = userSnap.data().role || "user"; // Varsayılan olarak user kabul et
          setUserRole(role);
        } else {
          setUserRole("user");
        }
      } else {
        setIsAuthenticated(false);
        setUserRole(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = () => {
    signOut(auth).then(() => {
      setIsAuthenticated(false);
      setUserRole(null);
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/";
    });
  };

  if (loading) {
    return <h2>Loading...</h2>;
  }

  return (
    <div>
      {isAuthenticated && userRole === "admin" && <button onClick={handleLogout}>Logout</button>}
      <Routes>
        {/* Eğer giriş yapılmışsa ve adminse "/orders" sayfasına yönlendir */}
        <Route path="/" element={isAuthenticated && userRole === "admin" ? <Navigate to="/orders" /> : <AdminLogin setAuth={setIsAuthenticated} />} />

        {/* Sadece adminler erişebilir */}
        <Route path="/orders" element={isAuthenticated && userRole === "admin" ? <OrdersPage /> : <Navigate to="/" />} />
        <Route path="/subscriptions" element={isAuthenticated && userRole === "admin" ? <SubscriptionsPage /> : <Navigate to="/" />} />
      </Routes>
    </div>
  );
}

export default App;
